'use client';

import { useEffect } from 'react';
import { useSearchParams } from 'next/navigation';

import { usePathname } from '@/src/i18n/navigation';
import { incrementPis } from './pis';

/**
 * Counts page views into the `pis` cookie. Legacy increments from its router
 * listener on every history transition — including the first client render and
 * query-only changes such as a filter edit — so this keys off pathname and
 * search and fires on mount too.
 */
export function usePisPageCount(): void {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const search = searchParams?.toString() ?? '';

  useEffect(() => {
    incrementPis();
  }, [pathname, search]);
}
